import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { iOSPopupModal } from './iOSPopupModal.component';
import { TooltipComponent } from './tooltip.component';
import { LocaleModule } from '../Locale/locale.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    MatDialogModule,
    LocaleModule
  ],
    declarations: [TooltipComponent, iOSPopupModal],
    exports: [
        TooltipComponent,
        iOSPopupModal,
        MatTooltipModule,
        MatDialogModule
    ]
})
export class TooltipModule { }
